// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Sq-z","selected":"Tq-z"};